/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import Button from "../../extras/Button";
import { ExInput } from "../../extras/Input";
import { useDispatch } from "react-redux";
import { closeDialog } from "../../../redux/slice/dialogueSlice";
import { addUser } from "../../../redux/slice/userSlice";

export const UserDialogue = () => {
  const dispatch = useDispatch();
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [mobile, setMobile] = useState("");
  const [gender, setGender] = useState("");
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState({
    fname: "",
    lname: "",
    mobile: "",
    email: "",
    gender: "",
  });

  const isEmailValid = /\S+@\S+\.\S+/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    let error = {};

    if (!lname) error.lname = "Last name is required";
    if (!fname) error.fname = "First name is required";
    if (!mobile) {
      error.mobile = "Mobile number is required";
    } else if (mobile.length < 6 || mobile.length > 13) {
      error.mobile = "Mobile number must be 6 to 13 digits";
    }
    if (!email) error.email = "Email is required";
    if (!gender) error.gender = "Gender is required";

    if (Object.keys(error).length > 0 || !isEmailValid) {
      if (!isEmailValid) error.email = "Email address is invalid";
      setError({ ...error });
      setIsSubmitting(false);
      return;
    }

    const formData = new FormData();
    formData.append("lname", lname);
    formData.append("fname", fname);
    formData.append("email", email);
    formData.append("mobile", mobile);
    formData.append("gender", gender);
    formData.append("password", "password");
    formData.append("loginType", 1);

    dispatch(addUser(formData)).then((res) => {
      // console.log(res);
      if (res?.payload?.status) {
        dispatch(closeDialog());
      }
      setIsSubmitting(false);

    });
  };

  return (
    <div className="dialog">
      <div className="w-100">
        <div className="row justify-content-center">
          <div className="col-xl-5 col-md-8 col-11">
            <div className="mainDiaogBox">
              <div className="row justify-content-between align-items-center formHead">
                <div className="col-8">
                  <h2 className="text-theme m0">Add New Customer</h2>
                </div>
                <div className="col-4">
                  <div
                    className="closeButton"
                    onClick={() => {
                      dispatch(closeDialog());
                    }}
                  >
                    <i className="ri-close-line"></i>
                  </div>
                </div>
              </div>

              <div className="row align-items-start formBody">
                <div className="col-12 col-md-6">
                  <ExInput
                    type="text"
                    id="fname"
                    name="fname"
                    value={fname}
                    label="First name"
                    placeholder="First name"
                    errorMessage={error.fname}
                    onChange={(e) => {
                      setFname(e.target.value);
                      setError((prev) => ({
                        ...prev,
                        fname: e.target.value ? "" : "First Name Is Required",
                      }));
                    }}
                  />
                </div>

                <div className="col-12 col-md-6">
                  <ExInput
                    type="text"
                    value={lname}
                    id="lname"
                    name="lname"
                    label="Last Name"
                    placeholder="Last Name"
                    errorMessage={error.lname}
                    onChange={(e) => {
                      setLname(e.target.value);
                      setError((prev) => ({
                        ...prev,
                        lname: e.target.value ? "" : "Last Name Is Required",
                      }));
                    }}
                  />
                </div>

                <div className="col-12 col-md-6">
                  <ExInput
                    type="number"
                    value={mobile}
                    id="mono"
                    name="mobile"
                    label="Mobile Number"
                    minLength={6}
                    maxLength={13}
                    placeholder="Mobile Number"
                    errorMessage={error.mobile}
                    onChange={(e) => {
                      const val = e.target.value;
                      setMobile(val);
                      if (!val) {
                        setError((prev) => ({
                          ...prev,
                          mobile: "Mobile Number Is Required",
                        }));
                      } else if (val.length < 6 || val.length > 13) {
                        setError((prev) => ({
                          ...prev,
                          mobile: "Mobile number must be 6 to 13 digits",
                        }));
                      } else {
                        setError((prev) => ({ ...prev, mobile: "" }));
                      }
                    }}
                  />
                </div>

                <div className="col-12 col-md-6">
                  <ExInput
                    type="text"
                    id="email"
                    name="email"
                    label="Email"
                    value={email}
                    placeholder="Email"
                    errorMessage={error.email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setError((prev) => ({
                        ...prev,
                        email: e.target.value ? "" : "Email Id is Required",
                      }));
                    }}
                  />
                </div>

                <div className="d-flex justify-content-between col-12 col-md-6 mt-md-5 mt-sm-0">
                  <span
                    className={`fs-16 fw-600 ${error.gender ? "text-danger" : ""}`}
                  >
                    Gender:
                  </span>
                  <div className="col-4 ms-2">
                    <ExInput
                      type="radio"
                      id="male"
                      label="Male"
                      name="gender"
                      value="male"
                      checked={gender === "male"}
                      onChange={(e) => {
                        setGender(e.target.value);
                        setError((prev) => ({ ...prev, gender: "" }));
                      }}
                    />
                  </div>
                  <div className="col-4">
                    <ExInput
                      type="radio"
                      id="female"
                      label="Female"
                      name="gender"
                      value="female"
                      checked={gender === "female"}
                      onChange={(e) => {
                        setGender(e.target.value);
                        setError((prev) => ({ ...prev, gender: "" }));
                      }}
                    />
                  </div>
                </div>

                {error.gender && (
                  <div className="col-12 text-danger mt-1 mb-2">{error.gender}</div>
                )}
              </div>

              <div className="row formFooter">
                <div className="col-12 text-end m0">
                  <Button
                    className="bg-gray text-light"
                    text="Cancel"
                    type="button"
                    onClick={() => dispatch(closeDialog())}
                  />
                  <Button
                    type="submit"
                    className="bg-theme text-light m10-left"
                    text={isSubmitting ? "Submitting..." : "Submit"}
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};